import { db, eventRefs } from '@/fireinit'
import { arrayUnique } from '@/utilities/arrayHelpers'

// indexedDB promises
// import { openDB, deleteDB, wrap, unwrap } from 'idb';
import { openDB, deleteDB } from 'idb/with-async-ittr.js'

const SHOW_CONSOLE = false

function convertDatetimes(showtimes) {
    Object.keys(showtimes).forEach(key => {
        showtimes[key].startTime = new Date(showtimes[key].startTime)
        showtimes[key].endTime = new Date(showtimes[key].endTime)
    })
    return showtimes
}

const NOW = new Date()

const state = {
    EVENT_TYPES: ['concert', 'theatre', 'exhibition', 'festival', 'stage', 'atelier'],
    allEvents: [],
    eventTypes: null,
    fetchedVenues: [],
    selectedCity: 'Ankara',
    typePhotos: null,
    displayedEvent: { data: {}, id: '' },
    displayedVenue: { data: { displayName: '' }, id: '' },
    favoriteItemsList: [],

}

const mutations = {
    SET_EVENTS: (state, p) => { state.allEvents = p },
    SET_DISPLAYED_EVENT: (state, p) => state.displayedEvent = p,
    SET_DISPLAYED_VENUE: (state, p) => { state.displayedVenue = p; console.log('venue', p) },
    SET_DISPLAYED_VENUE_NAME: (state, p) => { state.displayedVenue.data.displayName = p; console.log('venue name', p) },
    SET_DISPLAYED_EVENT_NAME: (state) => state.displayedEvent.data.eventName,
    SET_EVENT_TYPES: (state, p) => state.eventTypes = p,
    SET_FAVORITE_ITEMS_LIST: (state, p) => state.favoriteItemsList = p,
    ADD_TO_FAVORITE_ITEMS_LIST: (state, p) => {
        if (state.favoriteItemsList.includes(p)) {
            state.favoriteItemsList = state.favoriteItemsList.filter(id => id !== p)
        } else {
            state.favoriteItemsList.push(p)
        }
    }
}

const actions = {
    // TYPES
    fetchEventTypes({ commit }) {
        return db.doc('types/event-types').get()
            .then(qSnap => {
                const eventTypes = qSnap.data()
                commit("SET_EVENT_TYPES", eventTypes)
            })
            .catch(error => {
                if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                    console.log(error)
                }
            })
    },
    async fetchTypePhotos({ dispatch }) {

        const typePhotos = await dispatch('getItemsFromLocalStorage', { key: 'typePhotos' })
        if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
            console.log('SERVING from local storage typePhotos', typePhotos);
        }
        if (typePhotos.length > 0) {
            // console.log('SERVING from local storage typePhotos', typePhotos);
            return typePhotos
        }

        try {
            const docSnap = await db.doc('types/event-types/type-photos/type-photos').get()
            const p = docSnap.data()


            dispatch('addItemsToLocalStorage', { value: p, key: 'typePhotos' })

            return p
        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error)
            }
        }


    },
    // EVENTS
    async fetchFeaturedEvents({ dispatch }, { orderLimit = 1, eventType }) {

        try {
            // let events = []
            const events = await dispatch('getItemsFromIndexedDB', { storeName: `featuredEventsStore` })
            if (events.length >= orderLimit) {
                if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                    console.log('SERVING from indexedDB storage featuredEvents:', events);
                }
                if (eventType.length) {
                    return events.filter(e => e.data.eventMainType === eventType)
                }
                return events.slice(0, 12)
            }

            // let qSnap = null;
            const qSnap = await db.doc('home-page/featured-events').get()
            let result = qSnap.data()

            if (!result.events) {
                return []
            }

            result.events.forEach(item => {
                item.data.eventShowtimes = convertDatetimes(item.data.eventShowtimes)
            })

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('HOME PAGE FEATURED EVENTS', result);
            }

            // dispatch('addItemsToIndexedDB', { items: es, storeName: `eventStore`, indexName: 'eventMainType', indexKey: eventType })
            dispatch('addItemsToIndexedDB', { items: result.events, storeName: 'featuredEventsStore', indexName: 'eventMainType' })


            if (eventType.length) {
                return result.events.filter(e => e.data.eventMainType === eventType)
            }
            return result.events

        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error)
            }
        }
    },
    async fetchEventByID(_, payload) {
        // commit('SET_DISPLAYED_EVENT_NAME', '')

        if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
            console.log('fetching event by id :', payload.id)
        }
        try {
            // get event snapshots
            const eventDataSnap = eventRefs(payload.id).eventDataDoc.ref.get()
            const eventSuperSnap = eventRefs(payload.id).eventSuperSettingsDoc.ref.get()
            const eventDetailsInfoSnap = eventRefs(payload.id).eventDetailsInfoDoc.ref.get()
            const eventTicketInfoSnap = eventRefs(payload.id).eventTicketInfoDoc.ref.get()

            // wait all promises to settle
            const [EDS, ESS, EDIS, ETIS] = await Promise
                .all([eventDataSnap, eventSuperSnap, eventDetailsInfoSnap, eventTicketInfoSnap])

            // build event object
            const event = {
                id: EDS.id,
                data: EDS.data(),
                settings: { super: ESS.data() },
                details: EDIS.data(),
                ticket: { ticketInfo: ETIS.data() }
            }

            event.data.eventShowtimes = convertDatetimes(event.data.eventShowtimes)

            // commit('user/SET_DISPLAYED_EVENT', event, { root: true })
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('fetched and set displayed event', event)
            }
            return event

        } catch (error) {
            console.log('error', error)
        }
    },
    async fetchEventsByVenueID({ dispatch }, { orderLimit = 10, venueID, }) {
        if (!venueID.length) {
            return null
        }

        const events = await dispatch('getItemsFromIndexedDBByIndex',
            { storeName: `eventStore`, indexName: 'eventVenueID', indexKey: venueID })

        if (events.length >= orderLimit) {
            // console.log('fetchEventsByType: items are served from index db', events);
            return events.slice(0, orderLimit)
        }

        try {
            const qSnap = await db.collection('events')
                .where('eventStatus', '==', 'active')
                .where('eventVenueID', '==', venueID)
                .orderBy('eventShowtimes.0.startTime', 'asc')
                .limit(orderLimit)
                .get()

            const es = qSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })

            es.forEach(event => {
                event.data.eventShowtimes = convertDatetimes(event.data.eventShowtimes)
            })

            dispatch('addItemsToIndexedDB', { items: es, storeName: `eventStore`, indexName: 'eventMainType' })

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log("all fetched events by venue id", es)
            }
            return es

        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error)
            }
        }
    },
    async fetchEventsByType({ rootState, dispatch }, { orderLimit = 3, eventType = '', eventSubtypes = '' }) {
        if (!eventType.length) return []

        if (!eventSubtypes.length) {
            // get data from local db
            let events = []
            events = await dispatch('getItemsFromIndexedDBByIndex',
                { storeName: `eventStore`, indexName: 'eventMainType', indexKey: eventType })

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('EVENtS LEN', events.length, 'orderLimit', orderLimit);
            }

            if (events.length >= orderLimit) {
                if (orderLimit > 20) {
                    return events
                }
                return events.slice(0, orderLimit)
            }
        }

        let source = 'default'

        if (orderLimit > 20) {
            orderLimit = 100
        }

        // eventSubtypes = []
        try {
            let qSnap
            if (!eventSubtypes.length) {
                qSnap = await db.collection('events')
                    .where('eventStatus', '==', 'active')
                    .where('eventMainType', '==', eventType)
                    .where('eventCity', '==', rootState.user.userCity)
                    .orderBy('eventShowtimes.0.startTime', 'asc')
                    .limit(orderLimit)
                    .get({ source })
            } else {
                console.log('SUBTYPES 2', JSON.parse(JSON.stringify(eventSubtypes)));
                qSnap = await db.collection('events')
                    .where('eventStatus', '==', 'active')
                    .where('eventMainType', '==', eventType)
                    .where('eventSubTypes', 'array-contains-any', JSON.parse(JSON.stringify(eventSubtypes)))
                    .where('eventCity', '==', rootState.user.userCity)
                    .orderBy('eventShowtimes.0.startTime', 'asc')
                    .limit(orderLimit)
                    .get({ source })
            }

            const es = qSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })
            es.forEach(event => {
                event.data.eventShowtimes = convertDatetimes(event.data.eventShowtimes)
            })

            dispatch('addItemsToIndexedDB', { items: es, storeName: `eventStore`, indexName: 'eventMainType' })
            // dispatch('addItemsToLocalStorage', { value: es, key: 'events' })
            return es

        } catch (error) {
            if (error.code === 'permission-denied') {
                // window.location.reload();
            }
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error)
            }
            return error
        }


    },
    // SEARCH
    async makeSearch({ dispatch }, val) {
        try {
            let eventRes = []
            let venueRes = []


            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log("val", val);
            }

            if (val.length <= 2 || val.length > 3) {
                if (process.env.NODE_ENV === 'development' ) {
                    console.log('in app search');
                }

                let events = await dispatch('getItemsFromIndexedDB', { storeName: 'eventStore' })
                if (!events) events = []

                eventRes = events.filter(option => {
                    return (
                        option.data.eventName
                            .toLocaleLowerCase()
                            .indexOf(val.toLocaleLowerCase()) >= 0
                    )
                })

                let venues = await JSON.parse(localStorage.getItem('venues'))
                if (!venues) venues = []

                venueRes = venues.filter(option => {
                    return (
                        option.data.displayName
                            .toLocaleLowerCase()
                            .indexOf(val.toLocaleLowerCase()) >= 0
                    )
                })
            }

            if (val.length === 3) {
                let v = val.trim().slice(0, 2).toLocaleLowerCase()


                if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                    console.log('db search');
                }
                const eventQSnap = await db.collection('events')
                    .where('firstTwoChars', '==', v)
                    .where('eventStatus', '==', 'active')
                    // .orderBy('eventDateTime.startTime', 'asc')
                    .get()

                const venueQSnap = await db.collection('users')
                    .where('firstTwoChars', '==', v)
                    .where('userType', '==', 'venue')
                    .get()


                eventRes = eventQSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })
                venueRes = venueQSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })

                dispatch('addItemsToIndexedDB', { storeName: 'eventStore', items: eventRes })
                dispatch('addItemsToIndexedDB', { storeName: 'userStore', items: venueRes })

                eventRes.forEach(event => {
                    event.data.eventShowtimes = convertDatetimes(event.data.eventShowtimes)
                })
                
            }

            return { events: eventRes, venues: venueRes }
        } catch (error) {

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error);
            }
        }
    },
    // VENUES
    async fetchVenueByID(_, payload) {
        // commit('SET_DISPLAYED_VENUE_NAME', '')
        if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
            console.log('fetching venue by id', payload.id);
        }
        try {
            // make parallel requests
            const venueDataSnap = db.doc(`users/${payload.id}`).get()
            // const venueSuperSnap = venueRefs(payload.id).venueSuperSettingsDoc.ref.get()
            const venueDetailsSnap = db.doc(`users/${payload.id}/user-general/user-public`).get()
            const venueFollowers = db.collection(`users/${payload.id}/followers`).get()

            const [VDS, VDSS, VF] = await Promise.all([venueDataSnap, venueDetailsSnap, venueFollowers])

            const venue = {
                id: VDS.id,
                data: VDS.data(),
                // settings: { super: VSS.data() },
                details: VDSS.data(),
                follows: {
                    stats: {
                        followersCount: 0,
                        followingsCount: 0,
                    },
                    followers: [],
                    followings: []
                }
            }

            if (!VF.empty)
                VF.docs.forEach(doc => {
                    if (doc.id === '--stats--') {
                        venue.follows.stats.followersCount = doc.data().followersCount
                    } else {
                        venue.follows.followers = doc.data().list
                    }
                })

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('fetched and prepered venue :', venue);
            }
            // commit('SET_DISPLAYED_VENUE', venue)
            return venue

        } catch (error) {

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.error(error);
            }
        }
    },
    fetchSponsoredVenues() {
        return db.collection('users')
            .limit(8)
            .where('userType', '==', 'venue')
            .get()
            .then(qSnap => {
                if (!qSnap.empty) {

                    const venues = qSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })

                    // console.log('venues', venues);
                    return venues
                } else {
                    return []
                }
            })
            .catch(error => {
                if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                    console.log(error)
                }
            })
    },
    fetchRecommendedVenues({ rootState }, payload /* venue, eventType */) {

        return db.collection('users')
            .limit(8)
            .where('venueType', '==', payload.venueType)
            .where('userCity', '==', rootState.user.userCity)
            // .where('venueType', '==', )
            .get()
            .then(qSnap => {

                if (!qSnap.empty) {

                    const venues = qSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })

                    // console.log('venues', venues);
                    return venues
                } else {
                    return []
                }
            })
            .catch(error => {
                if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                    console.log(error)
                }
            })
    },
    // COLLECTION CARDS
    async fetchCollectionCard({ dispatch }, { collectionName }) {

        const collectionCards = await dispatch('getItemsFromIndexedDBByIndex',
            { storeName: 'collectionCardStore', indexName: 'parentType', indexKey: collectionName, sortByDate: false })

        // console.log('COLLECTION', collectionCards);

        if (collectionCards.length > 1) {
            return collectionCards
        }

        try {
            const qSnap = await db.collection(`collection-cards/collections/${collectionName}-collections`)
                .where('status', '==', 'active')
                .get()

            if (!qSnap.empty) {
                const cards = qSnap.docs.map(doc => { return { id: doc.id, data: doc.data() } })
                dispatch('addItemsToIndexedDB', { items: cards, storeName: `collectionCardStore`, indexName: 'parentType' })
                return cards
            } else {
                return []
            }

        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error)
            }
            return error
        }

    },
    // INDEXED DB
    async deleteIDB({ }, { dbName }) {
        console.log('deleting idb');
        await deleteDB(dbName)
        console.log('idb is deleted');
        return true
    },
    async getIndexedDB({ }, { dbName = 'nereyelaDB', version = 1, storeName, indexName = '' }) {
        if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
            console.log('getting indexed db ', dbName, storeName, version, indexName);
        }

        const db = await openDB(dbName, version, {
            upgrade(db, oldVersion, newVersion, transaction) {

                // featuredEventsStore
                const featuredEventsStore = db.createObjectStore('featuredEventsStore')
                featuredEventsStore.createIndex('eventMainType', 'eventMainType')

                // eventStore
                const eventStore = db.createObjectStore('eventStore')
                eventStore.createIndex('eventMainType', 'eventMainType')
                eventStore.createIndex('eventName', 'eventName')
                eventStore.createIndex('eventVenueID', 'eventVenueID')
                eventStore.createIndex('eventCity', 'eventCity')

                // userStore
                const userStore = db.createObjectStore('userStore')
                userStore.createIndex('displayName', 'displayName')

                // collection card store
                const collectionCardStore = db.createObjectStore('collectionCardStore')
                collectionCardStore.createIndex('parentType', 'parentType')

                // favoriteEvents
                const favoriteEvents = db.createObjectStore('favoriteItemsList')
                // db.put('favoriteEvents', 'tajpQyXHw4ZFlloba655')

            }
        })
        return db
    },
    async addItemsToIndexedDB({ dispatch }, { items, dbName = 'nereyelaDB', storeName, version = 1, indexName }) {
        if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
            console.log('\nAdding items to indexed db\n');
        }

        const IDB = await dispatch('getIndexedDB', { dbName, storeName, indexName })

        // write to db
        const tx = IDB.transaction(storeName, 'readwrite')
        const store = tx.objectStore(storeName)

        if (items.length) {
            for await (const item of items) {
                const next = await store.get(item.id)
                if (next) {

                } else {
                    const data = item.data
                    data.id = item.id
                    await store.add(data, item.id)
                }
            }
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('items are added to indexedDB: ', items);
            }
        }
        await tx.done

    },
    async getItemsFromIndexedDB({ dispatch }, { dbName, storeName, version, sortByDate = true }) {

        let items = []
        try {
            const IDB = await dispatch('getIndexedDB', { storeName })

            const allItems = await IDB.getAll(storeName)
            for await (const item of allItems) {
                if (NOW.getTime() > new Date(item.eventShowtimes[0].startTime).getTime()) {
                    // console.log('item to be deleted from indexed db', item);
                    await IDB.delete(storeName, item.id)
                } else {
                    items.push({ data: item, id: item.id })
                }
            }
            if (sortByDate) {
                items = items.sort((a, b) => a.data.eventShowtimes[0].startTimeTimestamp.seconds - b.data.eventShowtimes[0].startTimeTimestamp.seconds);
            }

        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error);
            }
        }

        return items
    },
    async getItemsFromIndexedDBByIndex({ dispatch }, { dbName, storeName, version, indexName, indexKey, sortByDate = true }) {

        let items = []
        try {
            const IDB = await dispatch('getIndexedDB', { storeName, indexName })
            const allItems = await IDB.getAllFromIndex(storeName, indexName, indexKey)
            for await (const item of allItems) {
                // delete passed events from indexed db
                if (sortByDate && NOW.getTime() > new Date(item.eventShowtimes[0].startTime).getTime()) {
                    // console.log('item to be deleted from indexed db', item);
                    await IDB.delete(storeName, item.id)
                } else {
                    items.push({ data: item, id: item.id })
                }
            }

            if (sortByDate) {
                items = items.sort((a, b) => a.data.eventShowtimes[0].startTimeTimestamp.seconds - b.data.eventShowtimes[0].startTimeTimestamp.seconds);
            }

            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                // console.log('got items from indexed db, storename', items);
            }
        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log(error);
            }
        }
        return items
    },
    async getItemsFromIndexedDBById({ dispatch, state }, { dbName, storeName, version, indexName, idList }) {
        let items = []

        // if (!idList) idList = state.favoriteItemsList
        idList = state.favoriteItemsList
        try {
            const IDB = await dispatch('getIndexedDB', { storeName })
            const tx = IDB.transaction(storeName, 'readwrite')
            const store = tx.objectStore(storeName)

            if (idList.length) {
                for await (const id of idList) {
                    const next = await store.get(id)
                    console.log('next', next);
                    if (next) {
                        items.push(next)
                    }
                }
            }
            await tx.done

            if (process.env.NODE_ENV === 'development') {
                console.log('got items from indexed db, storename', items);
            }

            console.log('items by id', items);

            return items

        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log(error);
            }
        }
        return items
    },
    // FAVORITE EVENT
    async prepareFavoritesList({ commit, dispatch }) {

        // get indexedDB
        const storeName = 'favoriteItemsList'
        const IDB = await dispatch('getIndexedDB', { storeName })

        // fetch starred items list from indexedDB
        const allItems = await IDB.getAll(storeName)
        const favoriteItemsIdList = []
        allItems.forEach(item => favoriteItemsIdList.push(item.id))
        commit('SET_FAVORITE_ITEMS_LIST', favoriteItemsIdList)
    },
    async addToFavoriteItems({ commit, dispatch }, event) {
        const storeName = 'favoriteItemsList';
        const IDB = await dispatch('getIndexedDB', { storeName })

        // if already is in the store remove it
        const itemInStore = await IDB.get(storeName, event.id)
        if (itemInStore) {
            await IDB.delete(storeName, event.id)
            commit('ADD_TO_FAVORITE_ITEMS_LIST', event.id)
        } else {
            try {
                console.log('addToFavoriteItems', event);
                await IDB.add(storeName, event, event.id)
                commit('ADD_TO_FAVORITE_ITEMS_LIST', event.id)
            } catch (error) {
                if (process.env.NODE_ENV === 'development') {
                    console.log(error);
                }
            }
        }
    },
    // LOCAL STORAGE
    addItemsToLocalStorage(_, payload) {

        // last refresh time to show new content is avaliable
        // localStorage.setItem('lastRefreshTime', new Date().getTime())

        // return 
        if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
            // console.log('OBJECT TO BE ADDED TO LOCAL STORAGE', payload.key, payload.value);
        }

        let items = []
        try {
            const itemsFromLocalStorage = JSON.parse(localStorage.getItem(payload.key))
            if (itemsFromLocalStorage) items = itemsFromLocalStorage;
        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('no local storage', error);
            }
        }

        items = items.concat(payload.value)
        items = arrayUnique(items)

        try {
            const parsed = JSON.stringify(items)
            localStorage.setItem(payload.key, parsed)
        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('localstorage error', error);
            }
        }

    },
    getItemsFromLocalStorage(_, payload) {

        // payload.eventMainType
        let evs = []
        try {
            evs = JSON.parse(localStorage.getItem(payload.key))
            if (!evs) return []
            // console.log('EVENTS from local storage', evs);

            if (payload.eventMainType) {
                evs = evs.filter(e => e.data.eventMainType === payload.eventMainType)
            }
            if (payload.key === 'events' || payload.key === 'featuredEvents') {
                evs.forEach(event => {
                    event.data.eventShowtimes = convertDatetimes(event.data.eventShowtimes)
                })
            }

            // TODO add typePhotos to localStorage in a better way
            if (payload.key === 'typePhotos') {
                return evs[0]
            }

            return evs
        } catch (error) {
            if (process.env.NODE_ENV === 'development' && SHOW_CONSOLE) {
                console.log('no local storage for', payload.key, 'error:', error);
            }
            return []
        }
    },
    addCollectionsToLocalStorage(_, payload) {
        // return
        // console.log('COLELCTIONS TO BE ADDED TO LOCAL STORAGE', payload.key, payload.value);
        ;
        let items = []
        try {
            const colItems = localStorage.getItem(`${payload.key}Collection`)
            const itemsFromLocalStorage = JSON.parse(colItems)
            // console.log('COLELCTIONS itemsFromLocalStorageE', itemsFromLocalStorage);

            if (itemsFromLocalStorage) items = itemsFromLocalStorage;
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('no local storage', error);
            }
        }

        items = items.concat(payload.value)
        // console.log('concated events with payload', events);

        items = arrayUnique(items)
        // console.log('unqieue events with payload', events);

        try {
            const parsed = JSON.stringify(items)
            localStorage.setItem(`${payload.key}Collection`, parsed)
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('localstorage error', error);
            }
        }

    },
    getCollectionsFromLocalStorage(_, payload) {
        // return []
        // payload.eventMainType
        // console.log('COLLEC NAME', payload.key);
        let evs = []
        try {
            const items = localStorage.getItem(`${payload.key}Collection`)
            evs = JSON.parse(items)
            // console.log('cOLLECTIONs  from local storage', evs);
            if (!evs) return []

            return evs
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('no local storage', error);
            }
        }
    },

}

const getters = {
    // EVENT
    // getAllEvents: state => state.allEvents,
    eventTypes: state => state.eventTypes,
    getEventByID: (state) => (eventID) => state.allEvents.find(e => e.id === eventID),
    getEventsByType: (state) => (eventType) =>
        state.allEvents.filter(e => e.data.eventMainType === eventType),
    // VENUE
    selectedCity: state => state.selectedCity,
    getEventsBySubtype: (state) => (subtypes) => {
        let list = []
        state.allEvents.forEach(e => {
            if (e.data.eventSubTypes.some(r => subtypes.indexOf(r) >= 0))
                list.push(e)
        })
        return list
    },
    getFavoriteItemsList: state => state.favoriteItemsList,

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}